import {BankAccountRequestBody, BankAccountResponseBody, Money} from '@dms/api/shared';

export type CancelPaymentPrescriptionApiResponse =
  /** status 200  */ PaymentPrescriptionResponseBody;
export type CancelPaymentPrescriptionApiArg = {
  paymentPrescriptionId: string;
};
export type ConfirmPaymentPrescriptionApiResponse =
  /** status 200  */ PaymentPrescriptionResponseBody;
export type ConfirmPaymentPrescriptionApiArg = {
  paymentPrescriptionId: string;
};
export type CreateBankTransferTransactionApiResponse =
  /** status 200  */ BankTransferTransactionResponseBody;
export type CreateBankTransferTransactionApiArg = {
  createBankTransferTransactionRequestBody: CreateBankTransferTransactionRequestBody;
};
export type CreateCashTransactionApiResponse =
  /** status 200  */ CashAndCardTransactionResponseBody;
export type CreateCashTransactionApiArg = {
  createCashTransactionRequestBody: CreateCashTransactionRequestBody;
};
export type CreateOffsetTransactionApiResponse = /** status 200  */ OffsetTransactionResponseBody;
export type CreateOffsetTransactionApiArg = {
  createOffsetTransactionRequestBody: CreateOffsetTransactionRequestBody;
};
export type CreatePaymentPrescriptionApiResponse =
  /** status 200  */ PaymentPrescriptionResponseBody;
export type CreatePaymentPrescriptionApiArg = {
  createPaymentPrescriptionRequestBody: CreatePaymentPrescriptionRequestBody;
};
export type PairTransactionToPaymentPrescriptionApiResponse =
  /** status 200  */ PaymentPrescriptionResponseBody;
export type PairTransactionToPaymentPrescriptionApiArg = {
  paymentPrescriptionId: string;
  transactionId: string;
};
export type ShowPaymentPrescriptionApiResponse = /** status 200  */ PaymentPrescriptionResponseBody;
export type ShowPaymentPrescriptionApiArg = {
  paymentPrescriptionId: string;
};
export type UpdatePaymentPrescriptionApiResponse =
  /** status 200  */ PaymentPrescriptionResponseBody;
export type UpdatePaymentPrescriptionApiArg = {
  paymentPrescriptionId: string;

  updatePaymentPrescriptionRequestBody: UpdatePaymentPrescriptionRequestBody;
};
export type UnpairTransactionFromPaymentPrescriptionApiResponse =
  /** status 200  */ PaymentPrescriptionResponseBody;
export type UnpairTransactionFromPaymentPrescriptionApiArg = {
  paymentPrescriptionId: string;
  transactionId: string;
};
export type CancelTransactionFromPaymentPrescriptionApiResponse = {
  cancelledTransactionId: string;
  cancellingTransactionId: string;
};
export type CancelTransactionFromPaymentPrescriptionApiArg = {
  paymentPrescriptionId: string;
  transactionId: string;
};

export type BankTransferTransactionResponseBody = {
  id: string;
  type: 'bank_transfer';
  direction: 'incoming' | 'outgoing';
  paymentDate: string;
  price: Money;
  receiverBankAccount: BankAccountResponseBody | null;
  senderBankAccount: BankAccountResponseBody | null;
  variableSymbol?: string | null;
  constantSymbol?: string | null;
  specificSymbol?: string | null;
  message?: string | null;
  source: 'internal' | 'external';
};
export type CashAndCardTransactionResponseBody = {
  id: string;
  type: 'cash' | 'payment_card';
  direction: 'incoming' | 'outgoing';
  paymentDate: string;
  price: Money;
  source: 'internal' | 'external';
};
export type OffsetTransactionResponseBody = {
  id: string;
  type: 'offset';
  direction: 'incoming' | 'outgoing';
  paymentDate: string;
  price: Money;
  source: 'internal' | 'external';
};
export type PaymentPrescriptionResponseBody = {
  id: string;
  state:
    | 'draft'
    | 'canceled'
    | 'completed'
    | 'confirmed'
    | 'partially_paid'
    | 'overpayment'
    | 'reopened'
    | 'overdue';
  price: Money;
  pricePaid: Money;
  remainsToPay: Money;
  dueDate: string;
  paymentPairingId?: string | null;
  transactions: (
    | BankTransferTransactionResponseBody
    | CashAndCardTransactionResponseBody
    | OffsetTransactionResponseBody
  )[];
  direction: 'incoming' | 'outgoing';
  balance: Money;
  virtualBalance: Money;
};

export type CreateBankTransferTransactionRequestBody = {
  direction: 'incoming' | 'outgoing';
  paymentDate: string;
  price: Money;
  receiverBankAccount?: BankAccountRequestBody | null;
  senderBankAccount?: BankAccountRequestBody | null;
  variableSymbol?: string | null;
  constantSymbol?: string | null;
  specificSymbol?: string | null;
  message?: string | null;
};
export type CreateCashTransactionRequestBody = {
  direction: 'incoming' | 'outgoing';
  paymentDate: string;
  price: Money;
};
export type CreateOffsetTransactionRequestBody = {
  direction: 'incoming' | 'outgoing';
  paymentDate: string;
  price: Money;
};
export type CreatePaymentPrescriptionRequestBody = {
  price: Money;
  dueDate: string;
  direction: 'incoming' | 'outgoing';
  paymentPairingId?: string | null;
};
export type UpdatePaymentPrescriptionRequestBody = {
  price: Money;
  dueDate: string;
  direction: 'incoming' | 'outgoing';
  paymentPairingId?: string | null;
};
